export const ifc_o3_childKeys = [
  'FireFEI',
  'MotorFEI',
  'SeqVIFFEISum',
  'SeqVIFFEI125hrs',
  'SeqVIEFEISum',
  'SeqVIEFEI125hrs',
  'SeqIIIHKVInc',
  'SeqIIIHAvgWPD',
  'SeqIIIHStuckRings',
  'SeqIIIHACCSVis',
  'SeqIIIHAMRVVis',
  'ROBOCCSVis',
  'ROBOMRVVis',
  'SeqIIIHBPhosRet',
  'SeqIVAAvgCamWear',
  'SeqIVBAvgIntakeLoss',
  'SeqIVBEOTIron',
  'SeqVHAvgEngSludge',
  'SeqVHRockerCvrSludge',
  'SeqVHAvgEngVarnish',
  'SeqVHPistonSkirtVarnish',
  'SeqVHOilScreenSludge',
  'SeqVHOilScreenDebris',
  'SeqVHHotStuckRings',
  'SeqVHColdStuckRings',
  'SeqVHOilRingClog',
  'SeqVIIIBearWtLoss',
  'SeqVIII10HrKV',
  'SeqIXAvgEvents',
  'SeqVHNoEvents',
  'SeqXChainStretch',
  'CCSVis',
  'CCSTemp',
  'MRVVis',
  'MRVYS',
  'MRVTemp',
  'SBTVis',
  'SBTTemp',
  'SBTGraph',
  'GelIndex',
  'HTHS150',
  'KV40',
  'KV100',
  'KVI',
  'KV100Shear30',
  'Noack250Hr1',
  'SASH',
  'SASHCalc',
  'Boron',
  'Calcium',
  'Magnesium',
  'Moly',
  'Phos',
  'Sodium',
  'Zinc',
  'Sulfur',
  'TBN',
  'FoamSeqITend',
  'FoamSeqIStab',
  'FoamSeqIITend',
  'FoamSeqIIStab',
  'FoamSeqIIITend',
  'FoamSeqIIIStab',
  'FoamSeqIVTend',
  'FoamSeqIVStab',
  'TEOST33CTotal',
  'FWTFlowReduct',
  'FWTFlowReduct0.6',
  'FWTFlowReduct1.0',
  'FWTFlowReduct2.0',
  'FWTFlowReduct3.0',
  'ERWS0Hr24',
  'ERWS25Hr24',
  'BRT',
  'H&M',
  'TAN',
  'GCScan',
  'FTIRSCAN',
  'ACM1Vol',
  'ACM1Hard',
  'ACM1TSChg',
  'HNRB1Vol',
  'HNRB1Hard',
  'HNRB1TSChg',
  'VMQ1Vol',
  'VMQ1Hard',
  'VMQ1TSChg',
  'FKM1Vol',
  'FKM1Hard',
  'FKM1TSChg',
  'AEM1Vol',
  'AEM1Hard',
  'AEM1TSChg',
  'KV100ShearKRLmod',
  'Noack150Hr12',
  'CoreModNo',
  'CoCoreFormulationNo',
  'SeqIXAvgEventsFresh',
  'SeqIXNbrEventsFresh',
  'SeqIXAvgEventsAged',
  'SeqIXNbrEventsAged',
  'CuCorrosion130'
];
